import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CustomScrollbar from "@/components/_partials/CustomScrollbar.vue";
  import CurrencyList from "@/components/_partials/CurrencyList.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Currency',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomScrollbar, { class: "custom-scrollbar currencies-scrollbar controller-scrollbar" }, {
    default: _withCtx(() => [
      _createVNode(CurrencyList)
    ]),
    _: 1
  }))
}
}

})